var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4998 13.1667C9.94755 13.1667 9.49984 13.6144 9.49984 14.1667C9.49984 14.719 9.94755 15.1667 10.4998 15.1667V13.1667ZM10.5082 15.1667C11.0605 15.1667 11.5082 14.719 11.5082 14.1667C11.5082 13.6144 11.0605 13.1667 10.5082 13.1667V15.1667ZM17.8332 10C17.8332 14.0501 14.5499 17.3334 10.4998 17.3334V19.3334C15.6545 19.3334 19.8332 15.1547 19.8332 10H17.8332ZM10.4998 17.3334C6.44975 17.3334 3.1665 14.0501 3.1665 10H1.1665C1.1665 15.1547 5.34518 19.3334 10.4998 19.3334V17.3334ZM3.1665 10C3.1665 5.94993 6.44975 2.66669 10.4998 2.66669V0.666687C5.34518 0.666687 1.1665 4.84536 1.1665 10H3.1665ZM10.4998 2.66669C14.5499 2.66669 17.8332 5.94993 17.8332 10H19.8332C19.8332 4.84536 15.6545 0.666687 10.4998 0.666687V2.66669ZM9.49984 5.83335V12.5H11.4998V5.83335H9.49984ZM10.4998 15.1667H10.5082V13.1667H10.4998V15.1667Z",
    fill: "#FFA100"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.bd5ba2b6c24a1da2e5773d18a9194e6c.svg";
export { ForwardRef as ReactComponent };